import React from "react";
import { Link } from "react-router-dom";
import { LayoutGrid } from "lucide-react";

export default function FloatingMenuButton({ className = "" }) {
  return (
    <Link
      to="/"
      data-testid="floating-menu-btn"
      aria-label="Voltar ao menu principal"
      className={`fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-[#1B7A45] px-5 py-3 font-semibold text-white shadow-xl shadow-black/25 transition hover:scale-105 hover:bg-[#156337] ${className}`}
    >
      <LayoutGrid className="h-5 w-5" />
      Menu
    </Link>
  );
}
